export const PRODUCTION_STATUSES = [
  { key: 'pendiente', label: 'Nuevo' },
  { key: 'en_produccion', label: 'Pendiente' },
  { key: 'finalizado', label: 'Terminado' },
  { key: 'entregado', label: 'Entregado' },
];

export const DEFAULT_PRODUCTION_STATUS = 'pendiente';

export const PRODUCTION_STATUS_LABELS = PRODUCTION_STATUSES.reduce((acc, status) => {
  acc[status.key] = status.label;
  return acc;
}, {});

export const NEXT_PRODUCTION_STATUS = {
  pendiente: 'en_produccion',
  en_produccion: 'finalizado',
  finalizado: 'entregado',
};

export const PRODUCTION_PRIORITIES = [
  { key: 'baja', label: 'Baja' },
  { key: 'normal', label: 'Normal' },
  { key: 'alta', label: 'Alta' },
  { key: 'urgente', label: 'Urgente' },
];

export const PRODUCTION_PRIORITY_LABELS = PRODUCTION_PRIORITIES.reduce((acc, priority) => {
  acc[priority.key] = priority.label;
  return acc;
}, {});

export const PRODUCTION_PRIORITY_ORDER = {
  urgente: 0,
  alta: 1,
  normal: 2,
  baja: 3,
};

export const DEFAULT_PRODUCTION_PRIORITY = 'normal';
